import React from 'react'
import { Grid2, Typography } from '@mui/material'
import { GRAY_COLORS, INFO_COLORS, ERROR_COLORS, WARNING_COLORS } from 'asterX-UI'
import { useContractStore } from 'context/ContractStore'

const Stepper = ({ steps, currentStep }) => {
  const {
    contractStore: { stepCode, loanApplicationData }
  } = useContractStore()

  const getStepProps = (item, index) => {
    if (stepCode === 'serviceRefuse' && item?.codes?.includes('serviceRefuse')) {
      return {
        borderColor: ERROR_COLORS[600],
        textColor: ERROR_COLORS[600],
        text: 'Заявке отказано'
      }
    }
    if (
      stepCode === 'userAlternative' &&
      item?.codes?.includes('userAlternative') &&
      !loanApplicationData?.activity?.clientRefuse
    ) {
      return {
        borderColor: WARNING_COLORS[400],
        textColor: WARNING_COLORS[400],
        text: 'Альтернатива'
      }
    }
    if (stepCode === 'serviceInvalid' && item?.codes?.includes('serviceInvalid')) {
      return {
        borderColor: ERROR_COLORS[600],
        textColor: ERROR_COLORS[600],
        text: 'Ошибка'
      }
    }
    if (stepCode === 'userRevert' && item?.codes?.includes('userRevert')) {
      return {
        borderColor: WARNING_COLORS[600],
        textColor: WARNING_COLORS[600],
        text: 'Редактирование заявки'
      }
    }
    if (stepCode === 'userClientConsidering' && item?.codes?.includes('userClientConsidering')) {
      return {
        borderColor: WARNING_COLORS[400],
        textColor: WARNING_COLORS[500],
        text: 'Ожидание клиента'
      }
    }
    if (
      ['userUploadCollateralDocs', 'userUploadBankDocs', 'userClientAgreement', 'userAlternative'].includes(stepCode) &&
      item?.codes?.includes(stepCode) &&
      loanApplicationData?.activity?.clientRefuse
    ) {
      return {
        borderColor: ERROR_COLORS[600],
        textColor: ERROR_COLORS[600],
        text: 'Отказ клиента'
      }
    }

    const isActive = currentStep >= index
    return {
      borderColor: isActive ? INFO_COLORS[600] : GRAY_COLORS[200],
      textColor: currentStep === index ? INFO_COLORS[600] : 'inherit',
      text: item?.name
    }
  }

  return (
    <Grid2 container sx={{ gap: 2, justifyContent: 'space-between' }}>
      {steps?.map((item, index) => {
        const { borderColor, textColor, text } = getStepProps(item, index)

        return (
          <Grid2
            key={`${item?.name}-${index}`}
            sx={{
              borderTop: `4px solid ${borderColor}`,
              width: `calc(100% / ${steps.length} - 16px)`,
              cursor: 'pointer',
              '& p': {
                fontWeight: 600,
                color: textColor
              }
            }}
          >
            <Typography variant="body2" align="left" sx={{ marginTop: 1 }}>
              {text}
            </Typography>
          </Grid2>
        )
      })}
    </Grid2>
  )
}

export default Stepper
